require('./bootstrap');

require('./util');
require('./landing/main');
require('./children');
require('./form');

require('./mijn-wij/notifications');
